import { BASE64_ENCODED_REGEX, NUMBERS_REGEX } from '../constants/regex';
export var MERCHANT_ID = '379dc8f09a4311e7806bbc764e106cf4';
var getValidatedOGInputsValues = function () {
    var _a, _b, _c, _d;
    var hatOg = ((_a = window.THD_OG_GLOBAL) === null || _a === void 0 ? void 0 : _a.clientToken) || '';
    var hatOgTs = ((_b = window.THD_OG_GLOBAL) === null || _b === void 0 ? void 0 : _b.timestamp)
        ? String((_c = window.THD_OG_GLOBAL) === null || _c === void 0 ? void 0 : _c.timestamp)
        : '';
    var hatOgId = ((_d = window.THD_OG_GLOBAL) === null || _d === void 0 ? void 0 : _d.clientId) || '';
    var isHatOg = BASE64_ENCODED_REGEX.test(hatOg);
    var isHatOgTs = NUMBERS_REGEX.test(hatOgTs);
    return {
        hatOgId: hatOgId,
        hatOg: isHatOg ? hatOg : '',
        hatOgTs: isHatOgTs ? hatOgTs : '',
    };
};
export var getOrderGrooveAddressPayload = function (_a) {
    var name = _a.name, postalDetails = _a.postalDetails, primaryPhone = _a.primaryPhone;
    var _b = getValidatedOGInputsValues(), hatOgId = _b.hatOgId, hatOg = _b.hatOg, hatOgTs = _b.hatOgTs;
    var updatedValue = name && postalDetails && primaryPhone
        ? {
            merchant_id: encodeURIComponent(MERCHANT_ID),
            user: {
                user_id: encodeURIComponent(hatOgId),
                ts: encodeURIComponent(hatOgTs),
                sig: encodeURIComponent(hatOg),
            },
            shipping_address: {
                first_name: encodeURIComponent(name.firstName || ''),
                last_name: encodeURIComponent(name.lastName || ''),
                address: encodeURIComponent(postalDetails.addressLine1 || ''),
                address2: encodeURIComponent(postalDetails.addressLine2 || ''),
                city: encodeURIComponent(postalDetails.city || ''),
                state_province_code: encodeURIComponent(postalDetails.state || ''),
                zip_postal_code: encodeURIComponent(postalDetails.zipCode || ''),
                country_code: encodeURIComponent(postalDetails.country || ''),
                phone: encodeURIComponent(primaryPhone.number || ''),
            },
        }
        : {};
    return "update_request=".concat(JSON.stringify(updatedValue));
};
